<template>
    <Screen above="md">
        <slot />
    </Screen>
</template>

<script setup lang="ts">
import Screen from './Screen.vue'
</script>
